import React from 'react'

import MultiProgress from 'react-multi-progress'

export default function BarChart() {
 
  return (
    <div className='BarChartWidth'>
    <MultiProgress
			elements={[
				{
					value: 35,
					color: "blue",
          showPercentage: true,
				},
        {
					value: 35,
					color: "red",
          showPercentage: true,
				},
        {
					value: 30,
					color: "brown",
          showPercentage: true,
				},
			]}
		/>
    </div>

  )
}

